<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card class="risk-assessment scroll-form" height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{
            $vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()
          }}
        </v-card-title>
        <v-layout row wrap>
          <PowraTitle
            :avatar="'B'"
            :title="$vuetify.t('$vuetify.powra.meansOfAccessToWorkArea')"
          />

          <v-layout row wrap>
            <v-flex xs12 class="blue-grey lighten-5" px-3 pt-2>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.mobileScaffoldTower')"
                v-model="mobileScaffoldTower"
                class="mt-2"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.MEWP')"
                v-model="MEWP"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 class="blue-grey lighten-5" px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.trestlesStaging')"
                v-model="trestlesStaging"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.podiumSteps')"
                v-model="podiumSteps"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 class="blue-grey lighten-5" px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.stepLadder')"
                v-model="stepLadder"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.extensionLadder')"
                v-model="extensionLadder"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 class="blue-grey lighten-5" px-3 pt-3>
              <v-checkbox
                :label="$vuetify.t('$vuetify.powra.suspendedAccess')"
                v-model="suspendedAccess"
                class="mt-0 py-0"
                color="green"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row wrap px-3 pt-3>
          <v-flex xs12>
            <v-textarea
              outline
              v-model="other"
              :label="$vuetify.t('$vuetify.powra.other')"
            ></v-textarea>
          </v-flex>
        </v-layout>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>

            <v-btn color="success" @click="confirm()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted()" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  props: ['show'],
  components: {
    AbortVisit,
    PowraTitle
  },
  data() {
    return {
      dialog: false,
      mobileScaffoldTower: false,
      MEWP: false,
      trestlesStaging: false,
      podiumSteps: false,
      stepLadder: false,
      extensionLadder: false,
      suspendedAccess: false,
      other: null
    }
  },
  computed: {
    ...mapState({
      currentRiskAssessment: state => state.calls.currentRiskAssessment
    }),
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment'
    }),
    callDetail() {
      return this.getActiveCall
    }
  },
  methods: {
    confirm() {
      this.dialog = false
      this.$emit('confirmed', {
        mobile_scaffold_tower: this.mobileScaffoldTower,
        mewp: this.MEWP,
        trestles_staging: this.trestlesStaging,
        podium_steps: this.podiumSteps,
        step_ladder: this.stepLadder,
        extension_ladder: this.extensionLadder,
        suspended_access: this.suspendedAccess,
        other: this.other
      })
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    populateActivePowraValues() {
      this.mobileScaffoldTower = this.currentRiskAssessment.fields
        .workarea_access.mobile_scaffold_tower
        ? this.currentRiskAssessment.fields.workarea_access
            .mobile_scaffold_tower
        : false
      this.MEWP = this.currentRiskAssessment.fields.workarea_access.mewp
        ? this.currentRiskAssessment.fields.workarea_access.mewp
        : false
      this.trestlesStaging = this.currentRiskAssessment.fields.workarea_access
        .trestles_staging
        ? this.currentRiskAssessment.fields.workarea_access.trestles_staging
        : false
      this.podiumSteps = this.currentRiskAssessment.fields.workarea_access
        .podium_steps
        ? this.currentRiskAssessment.fields.workarea_access.podium_steps
        : false
      this.stepLadder = this.currentRiskAssessment.fields.workarea_access
        .step_ladder
        ? this.currentRiskAssessment.fields.workarea_access.step_ladder
        : false
      this.extensionLadder = this.currentRiskAssessment.fields.workarea_access
        .extension_ladder
        ? this.currentRiskAssessment.fields.workarea_access.extension_ladder
        : false
      this.suspendedAccess = this.currentRiskAssessment.fields.workarea_access
        .suspended_access
        ? this.currentRiskAssessment.fields.workarea_access.suspended_access
        : false

      this.other = this.currentRiskAssessment.fields.workarea_access.other
        ? this.currentRiskAssessment.fields.workarea_access.other
        : null
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
